const mpaaRatingOptions = [
  { label: 'G', value: 'g' },
  { label: 'PG', value: 'pg' },
  { label: 'PG-13', value: 'pg-13' },
  { label: 'TV-Y', value: 'tv-y' },
  { label: 'TV-Y7', value: 'tv-y7' },
  { label: 'TV-G', value: 'tv-g' },
  { label: 'TV-PG', value: 'tv-pg' },
  { label: 'TV-14', value: 'tv-14' },
  { label: 'TV-MA', value: 'tv-ma' },
  { label: 'NC-17', value: 'nc-17' },
  { label: 'R', value: 'R' },
];
const bbfcRatingOptions = [
  { label: 'U', value: 'u' },
  { label: 'PG', value: 'pg' },
  { label: '12', value: '12' },
  { label: '12A', value: '12a' },
  { label: '15', value: '15' },
  { label: '18', value: '18' },
  { label: 'R18', value: 'r18' },
];
const europeanFskRatingOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
  { label: '15', value: '15' },
  { label: '16', value: '16' },
  { label: '17', value: '17' },
  { label: '18', value: '18' },
];
const geoBlockingOptions = [
  { label: 'No geoblocking', value: 'NoGeoblocking' },
  { label: 'Allow in the following countries', value: 'AllowInTheFollowingCountries' },
  { label: 'Block in the following countries', value: 'BlockInTheFollowingCountries' },
];

const ShareContentOptions = [
  { label: 'No sharing', value: 'Nosharing' },
  { label: 'Share with Parent', value: 'ShareWithParent' },
  { label: 'Share with Parent and siblings OUs', value: 'Share withParent and siblings OUs' },
];

const newSeasonIdPrefix = 'temp-';

export {
  bbfcRatingOptions,
  europeanFskRatingOptions,
  geoBlockingOptions,
  mpaaRatingOptions,
  newSeasonIdPrefix,
  ShareContentOptions,
};
